<a
  [href]="this.href"
  target="_blank"
  rel="noopener noreferrer"
  style="text-decoration: none;"
  target="_blank"
>
  <i class="ri-question-line"></i>

</a>
